import { createFileRoute } from "@tanstack/react-router";
import { RobloxBioPage } from "../pages/RobloxBioPage";
import { site } from "../config/site";

const title = "Roblox Bio Maker - Aesthetic Roblox Bios Copy and Paste";
const description = "Create cute Roblox bios with fonts and symbols. Pick a Roblox bio template, customize your text, and copy and paste your finished bio into your profile.";
const canonical = `${site.origin}/roblox-bio/`;
const image = `${site.origin}/roblox-bio-social.png`;
const imageAlt = "Roblox Bio Maker with cute, aesthetic and dark profile cards, fonts and decorative symbols.";

export const Route = createFileRoute("/roblox-bio")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: canonical },
      { property: "og:locale", content: "en_US" },
      { property: "og:image", content: image },
      { property: "og:image:alt", content: imageAlt },
      { property: "og:image:width", content: "1734" },
      { property: "og:image:height", content: "907" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
      { name: "twitter:image", content: image },
      { name: "twitter:image:alt", content: imageAlt },
    ],
    links: [{ rel: "canonical", href: canonical }],
  }),
  component: RobloxBioPage,
});
